import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1>Creating Spaces That Inspire</h1>
            <p>We design exceptional architectural and interior spaces that blend functionality with aesthetic beauty, creating environments that enhance your lifestyle.</p>
            <div className="hero-buttons">
              <a href="#portfolio" className="btn">View Our Work</a>
              <a href="#contact" className="btn btn-outline">Get In Touch</a>
            </div>
          </div>
        </div>
      </div>
      <div 
        className="hero-image"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero-bg.jpg)`
        }}
      >
        <div className="hero-overlay"></div>
      </div>
    </section>
  );
};

export default Hero;
